import { gql } from '@apollo/client';

export const CREATE_PAYMENT_INTENT = gql`
  mutation ($data: PaymentIntentInput!) {
    createPaymentIntent(data: $data) {
      __typename
      ... on PaymentIntent {
        clientSecret
      }
      ... on PaymentIntentError {
        message
      }
      ... on InternalServerError {
        message
      }
    }
  }
`; 